import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'


export default WidthContainer
